import addMinutes from 'date-fns/addMinutes';
import {isAfter as isDateAfter, isBefore as isDateBefore,startOfDay} from 'date-fns';
import { getMinutesfromTimeString, getUTCDate } from '@dataGrid/gridUtilities';
import appConstant from "../../../src/appConstants";
import { OTHER_ROUTE_TYPES,OTHER_ROUTES_COMMENTS } from '../header/Dialogs/DynamicRouting/constants';
import { TAIL_LOADING_ZONE } from '../modules/Dispatch/RouteExecution/DriverPopUp/AddProDialog/constants';
import { getPendingStopStatus, checkIfETAInDeliveryRange } from '../modules/Dispatch/utils/utils';
import {routeHasMultipleTailLoadStops,routeHasTailLoadStopNotFirstSequence} from '../modules/IBPlanning/RoutesView/utils';
export default class CheckViolation{
    static checkAppointmentMissed = (params) => {
        const statusValueGetter = params.api.getColumnDef('stopStatus') && params.api.getColumnDef('stopStatus').valueGetter;
        if(statusValueGetter && statusValueGetter(params) === appConstant.STOP_STATUS.DELAYED){
            return 'Driver expected to arrive late at customer location';
        }
    }

    static checkPrepTimeGreaterThanStartTime = (params) => {
        const { stopPrepTime, routeStartTime } = params.data;
        const { planDate } = params;
        const [stopDate, stopTime] = stopPrepTime ? stopPrepTime.split(" ") : [null, null];

        if(stopPrepTime && planDate && !isDateBefore(stopDate, planDate) && (isDateAfter(stopDate, planDate) || CheckViolation.isTimeAfter(stopTime, routeStartTime))){
            return appConstant.VIOLATION_MESSAGES.LATE_PROS;
        }
    }

    static checkRouteProArrivingLate = ({data, context}) => {
      return context.getRouteProArrivingLateViolation(data.routeId);
    }

    static checkNumServiceViolation = (params) => {
        const { numServiceViolations } = params.data;
        if(numServiceViolations){
            return `${numServiceViolations} missed appointment${numServiceViolations > 1 ? 's':''}`;
        }
    }

    static checkLocationGeoCoded = (params) => {
      const { isGeoCoded } = params.data;
      if(isGeoCoded === false){
        return "Geocoding Required";
      }
    }

    static checkClosedCustomerViolation = ({isCustomerClosed}) => {
      if(isCustomerClosed){
        return "Customer is closed today";
      }
    }

    static checkClosedCustomerViolationForRouteStops = ({isCustomerClosed}) => {
      if(isCustomerClosed){
        return "One or more customers are closed today";
      }
    }

    static checkRouteLiftGateViolation = (params) => {
        const { lgProCount, routeId } = params.data;
        const { getTrailerNameForRoute, getTrailerInfo } = params.context;
        const trailerName = getTrailerNameForRoute?.(routeId);
        const trailer = getTrailerInfo?.(trailerName);
        if(lgProCount && trailer && !trailer.isLiftGateRequired){
            return 'Route needs a Liftgate trailer';
        }
    }

    static checkStopOrShipmentLiftGateViolation = ({ data, context = {}, colDef }) => {
      const { liftgate, routeId } = data;
      if (liftgate !== appConstant.SpecialNeedsStrings.L || !routeId) return null;
      const { getTrailerNameForRoute, getTrailerInfo } = context;
      const trailerName = getTrailerNameForRoute?.(routeId);
      const trailer = getTrailerInfo?.(trailerName);
      if (trailer && !trailer.isLiftGateRequired) {
        const entity = colDef?.gridTitle === appConstant.gridNames.StopsGrid ? 'Stop' : 'Shipment';
        return `${entity} needs a liftgate trailer`;
      }
      return null;
    };

    static checkRouteStartTimeViolation = (params) => {
        const { actualArrivalTime, shipmentEtaDateTime,  preparationTime, routeStartTime } = params.data;
        const { planDate }= params;
        const arrivalTime = actualArrivalTime || shipmentEtaDateTime;
        if(arrivalTime && routeStartTime) {
            const UtcFormatTime = getUTCDate(arrivalTime);
            const updatedTime = addMinutes(UtcFormatTime, preparationTime);
            if(planDate && !isDateBefore(startOfDay(updatedTime), planDate) && (isDateAfter(startOfDay(updatedTime), planDate) || CheckViolation.isTimeAfter(`${updatedTime.getHours()}:${updatedTime.getMinutes()}`, routeStartTime))){
              return 'Pro arriving too late for route start time';
            }
        }
    }
    //check if the first time after the second one.
    static isTimeAfter = (time, comparisonTime) => {
        return time && comparisonTime && getMinutesfromTimeString(time) > getMinutesfromTimeString(comparisonTime);
    }

    static checkNewProsInRoute = (params) => {
        const {data} = params;
        const { newShipments } = params.context || {};
        const newProsCount = newShipments && newShipments.data && newShipments.data.filter(pro => pro.routeName && pro.routeName !== appConstant.UNRTD_ROUTENAME && pro.routeName === data.routeName).length;
        return newProsCount ? `${newProsCount} New pro(s) added` : null;
    }

    static checkProIsNew = (params) => {
        const {data} = params;
        const { newShipments } =  params.context || {};
        const isNewPro = newShipments && newShipments.data && newShipments.data.some(pro => pro.proId === data.proId && pro.routeName === data.routeName);
        return isNewPro ? 'New pro' : null
    }

    static checkNewProsInStop = (params) => {
        const {data} = params;
        const { newShipments } =  params.context || {};
        const newProsCount = newShipments && newShipments.data && newShipments.data.filter(pro => pro.routeStopId === data.routeStopId && pro.routeName === data.routeName).length;
        return newProsCount ? `${newProsCount} New pro(s) added` : null;
    }

    static checkDriverHasDelayStops = (params) => {
        const { stops } = params.data;
        const hasDelayStops = stops?.some(
          (stop) =>
            !stop.isStopCompleted &&
            getPendingStopStatus(stop) === appConstant.STOP_STATUS.DELAYED
        );
        return hasDelayStops ? 'Driver expected to arrive late at customer location': null;
    };

    static checkEquipmentMatch = (params)=> {
        if (params.context?.hasEquipmentMismatch?.(params.data)) {
            return "Customer equipment preference mismatch";
        }
        return null;
    }

    static checkAnchorPointEquipmentMatch = (params)=> {
        if (params.context?.hasAnchorPointEquipmentMismatch?.(params.data)) {
            return "Anchor point equipment mismatch";
        }
        return null;
    }

    static checkPSEViolation = (params) => {
        const trailerData = params.context.trailersData.find(
          (trailer) => trailer.trailerId === params.data.trailerId
        );
        if (trailerData && params.data.isCapacityExceeded) {
          return 'PSE on this route is more than trailer capacity';
        }
        return null;
      };

      static checkNoFMERouteViolation = ({ data, context }) => {
        //show a violation, when we load the shipments of the customer on a FME trailer
        if (data.trailerLength !== appConstant.FME_ROUTE_TRAILER_LENGTH) {
          return null;
        }
        const isRouteHasNoFMECustomer = context.stopsList.find(
          (stop) => stop.routeId?.toLowerCase() === data.routeId?.toLowerCase() && stop.isNoFME
        );
        return isRouteHasNoFMECustomer ? appConstant.VIOLATION_MESSAGES.NON_FME_CUSTOMER_ROUTE : null;
      };

      static checkNoFMERouteStopViolation = ({ data, context }) => {
        if (!data.isNoFME) {
          return null;
        }
        const isNotFMEStopAssignedToFMERoute = context.routesList.find(
          (route) =>
            route.routeId?.toLowerCase() === data.routeId?.toLowerCase() &&
            route.trailerLength === appConstant.FME_ROUTE_TRAILER_LENGTH
        );
        return isNotFMEStopAssignedToFMERoute
          ? appConstant.VIOLATION_MESSAGES.NON_FME_CUSTOMER_ROUTE
          : null;
      };

      static checkNoFMEShipmentViolation = ({ data, context }) => {
        if (!data.isNoFME) {
          return null;
        }
        const isNotFMEShipmentAssignedToFMERoute = context.routesList.find(
          (route) =>
            route.routeId?.toLowerCase() === data.routeId?.toLowerCase() &&
            route.trailerLength === appConstant.FME_ROUTE_TRAILER_LENGTH
        );
        return isNotFMEShipmentAssignedToFMERoute
          ? appConstant.VIOLATION_MESSAGES.NON_FME_CUSTOMER_ROUTE
          : null;
      };

      static checkHazmatAndFoodViolation=(params)=>{
          if (params.data.hasFood && params.data.hasHazmat) {
              return 'Route has both food & hazmat shipments. Please verify hazmat shipment contains no poison';
            }
          return null;
      }

      static checkDelayedPriorityShipment = (params) => {
        const { deliveryWindow, actualArrivalTime, plannedArrivalTime } = params.data;
        const eta = getMinutesfromTimeString(actualArrivalTime || plannedArrivalTime);
        // Check if ETA is within any delivery window
        const isOnTime = checkIfETAInDeliveryRange(eta, deliveryWindow);
        return isOnTime ? null : 'Driver expected to arrive late at customer location';
      };

      static checkExtraTrailer = (params) => {
        if(params.data.comment?.includes("EXTRATRLR")){
          return 'Extra trailer required';
        }
        return null;
      }

      static checkExtraRouteNeeded = (params) => {
        if(params.data.comment?.includes(OTHER_ROUTE_TYPES.EXTRA_ROUTE_NEEDED)){
          return OTHER_ROUTES_COMMENTS[OTHER_ROUTE_TYPES.EXTRA_ROUTE_NEEDED];
        }
        return null;
      }

      static checkIsHoldPro = (data) => {
        const { isOnHold, isOnHoldRM } = data;
        if (isOnHoldRM) {
          return 'Pro is on hold (RouteMax)';
        }
        if (isOnHold) {
          return 'Pro is on hold';
        }
        return null;
      };
    
      static checkRouteHasHoldPro = ({ data, gridName }) => {
        const { isOnHold, isOnHoldRM } = data;
        if (isOnHoldRM) {
          return `${gridName} has RouteMax hold pro(s)`;
        }
        if (isOnHold) {
          return `${gridName} has hold pro(s)`;
        }
        return null;
      };

      static checkTailLoadRouteMultipleStops = ({ data, context }) => {
        return routeHasMultipleTailLoadStops(context.stopsList, data.routeId)
          ? appConstant.VIOLATION_MESSAGES.TAIL_LOAD_MULTIPLE_STOPS
          : null;
      };

      static checkTailLoadRouteStopNotFirst = ({ data, context }) => {
        return routeHasTailLoadStopNotFirstSequence(context.stopsList, data.routeId)
          ? appConstant.VIOLATION_MESSAGES.TAIL_LOAD_STOP_NOT_FIRST
          : null;
      };

      static checkTailLoadStopNotFirst = ({ data }) => {
        if (
          data.isTailLoad &&
          data.stopSequence !== appConstant.TAIL_LOAD_FIRST_STOP_SEQUENCE
        ) {
          return appConstant.VIOLATION_MESSAGES.TAIL_LOAD_STOP_NOT_FIRST;
        }
        return null;
      };

      static checkTailLoadShipmentLoadingZone = ({ data }) => {
        if (data.isTailLoad && data.loadingZone !== TAIL_LOADING_ZONE) {
          return appConstant.VIOLATION_MESSAGES.TAIL_LOAD_NO_LOADING_ZONE_T;
        }
        return null;
      };
}